export const BrandConstants = {
  name: import.meta.env.VITE_APP_NAME || "CMJ Cinema",
  bucketName: import.meta.env.VITE_SITE_BUCKET || "cmj-cinema-site",
  colors: {
    base: "#050505",
    red: "#ff1724",
    gold: "#ffc400",
    white: "#ffffff",
    ink: "#111111",
    mist: "#e7e7e7",
  },
  gradients: {
    spotlight:
      "linear-gradient(135deg, rgba(255, 8, 8, 0.18), rgba(0, 20, 39, 0.92) 52%, rgba(157, 122, 27, 0.24))",
    stage:
      "linear-gradient(180deg, rgba(9, 17, 29, 0.92), rgba(0, 20, 39, 1))",
  },
  contact: {
    email: import.meta.env.VITE_CONTACT_EMAIL || "admin@cmjcinema.com",
    phone: import.meta.env.VITE_CONTACT_PHONE || "(734) 795-5384",
    instagramUrl: import.meta.env.VITE_INSTAGRAM_URL || "",
  },
  copy: {
    heroTitle: "Brand & product photography guide.",
    heroSubtitle:
      "Stories. Brands. Moments. Captured with purpose.",
    availabilityHeadline: "Creative direction, clean delivery, and images built to move your brand.",
  },
} as const;
